<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <autogestion-log-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import AutogestionLogShowData from "./AutogestionLogShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "AutogestionLogShow",
        components: {CrudShow, AutogestionLogShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'cobrox.autogestionLog.showing',
            }
        },
    }
</script>

